// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 管理员后台全局样式 */

/* 基础样式重置 */
.admin-dashboard * {
  box-sizing: border-box;
}

/* 主容器 */
.admin-dashboard {
  display: flex;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  position: relative;
  overflow: hidden;
}

.admin-dashboard::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.2) 0%, transparent 50%);
  z-index: -1;
}

/* 移动端遮罩 */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  backdrop-filter: blur(4px);
}

/* 侧边栏 */
.admin-sidebar {
  width: 280px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(25px);
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 999;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 
    4px 0 25px rgba(0, 0, 0, 0.15),
    0 0 50px rgba(0, 245, 255, 0.05);
}

.admin-sidebar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(180deg, 
      rgba(0, 245, 255, 0.02) 0%, 
      rgba(0, 102, 255, 0.02) 50%, 
      rgba(138, 43, 226, 0.02) 100%);
  z-index: -1;
}

.admin-sidebar.collapsed {
  transform: translateX(-100%);
}

/* 移动端菜单按钮 - 全局样式确保在所有页面可见 */
.mobile-menu-btn {
  display: none;
  position: fixed !important;
  top: 20px !important;
  left: 20px !important;
  z-index: 1001 !important;
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(15px) !important;
  border: 2px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 16px !important;
  padding: 12px 20px !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 
    0 8px 25px rgba(0, 0, 0, 0.2),
    0 0 20px rgba(0, 245, 255, 0.1) !important;
  min-width: 100px !important;
}

.mobile-menu-btn.menu-open {
  background: rgba(255, 69, 69, 0.15) !important;
  border-color: rgba(255, 69, 69, 0.5) !important;
  box-shadow: 
    0 8px 25px rgba(255, 69, 69, 0.3),
    0 0 20px rgba(255, 69, 69, 0.2) !important;
}

.mobile-menu-btn.menu-open .menu-icon span {
  background: #ff4545 !important;
}

.mobile-menu-btn.menu-open .menu-text {
  color: #ff4545 !important;
}

.menu-icon {
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
  justify-content: center;
}

.menu-icon span {
  width: 20px;
  height: 2px;
  background: white !important;
  border-radius: 1px;
  transition: all 0.3s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.menu-open .menu-icon span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.menu-open .menu-icon span:nth-child(2) {
  opacity: 0;
}

.menu-open .menu-icon span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}

.menu-text {
  color: white !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
  letter-spacing: 0.5px !important;
  min-width: 35px !important;
  text-align: center !important;
}

.mobile-menu-btn:hover {
  background: rgba(255, 255, 255, 0.25) !important;
  border-color: rgba(0, 245, 255, 0.5) !important;
  transform: translateY(-2px) scale(1.05) !important;
  box-shadow: 
    0 12px 35px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(0, 245, 255, 0.2) !important;
}

.mobile-menu-btn:hover .menu-icon span {
  background: #00f5ff !important;
  box-shadow: 0 0 8px rgba(0, 245, 255, 0.5) !important;
}

.mobile-menu-btn:hover .menu-text {
  color: #00f5ff !important;
  text-shadow: 0 0 8px rgba(0, 245, 255, 0.3) !important;
}

.mobile-menu-btn.menu-open:hover {
  background: rgba(255, 69, 69, 0.25) !important;
  border-color: rgba(255, 69, 69, 0.7) !important;
  box-shadow: 
    0 12px 35px rgba(255, 69, 69, 0.4),
    0 0 30px rgba(255, 69, 69, 0.3) !important;
}

.mobile-menu-btn.menu-open:hover .menu-icon span {
  background: #ff2d2d !important;
  box-shadow: 0 0 8px rgba(255, 45, 45, 0.5) !important;
}

.mobile-menu-btn.menu-open:hover .menu-text {
  color: #ff2d2d !important;
  text-shadow: 0 0 8px rgba(255, 45, 45, 0.3) !important;
}

.mobile-menu-btn:active {
  transform: translateY(0) scale(0.98) !important;
}

/* 管理页面容器样式 */
.admin-page-container {
  padding-top: 40px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 300px;
    z-index: 999;
  }

  .admin-main {
    width: 100%;
  }

  .mobile-menu-btn {
    display: flex !important;
  }

  .admin-page-container {
    padding-top: 100px !important;
  }
}

@media (max-width: 480px) {
  .admin-sidebar {
    width: 280px;
  }

  .admin-page-container {
    padding-top: 100px !important;
  }
}

/* 底部登出按钮区域 */
.sidebar-logout {
  padding: 16px;
  border-top: 1px solid #34495e;
  text-align: center;
}

/* 右侧主区域 */
.admin-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

/* 可选顶部栏 */
.admin-header {
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

/* 内容区域 */
.admin-content {
  flex: 1 1; 
  padding: 20px;
  overflow: auto;
  background-color: #ffffff; /* 主内容白底 */
  box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
}`, "",{"version":3,"sources":["webpack://./src/styles/adminDashboard.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd,WAAW;AACX;EACE,sBAAsB;AACxB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;EAC7D,4DAA4D;EAC5D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;oFAGkF;EAClF,WAAW;AACb;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,QAAQ;AACR;EACE,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,iDAAiD;EACjD,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;EACjD;;oCAEkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;oCAIkC;EAClC,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,gDAAgD;EAChD,sCAAsC;EACtC,qDAAqD;EACrD,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,0BAA0B;EAC1B,4DAA4D;EAC5D;;8CAE4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C;;8CAE4C;AAC9C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,oDAAoD;EACpD,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD;;8CAE4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;EAC/C;;8CAE4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,aAAa;AACb;EACE,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,yBAAyB,EAAE,UAAU;EACrC,yCAAyC;AAC3C","sourcesContent":["/* 管理员后台全局样式 */\r\n\r\n/* 基础样式重置 */\r\n.admin-dashboard * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* 主容器 */\r\n.admin-dashboard {\r\n  display: flex;\r\n  min-height: 100vh;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.admin-dashboard::before {\r\n  content: '';\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: \r\n    radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),\r\n    radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),\r\n    radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.2) 0%, transparent 50%);\r\n  z-index: -1;\r\n}\r\n\r\n/* 移动端遮罩 */\r\n.mobile-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 998;\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n/* 侧边栏 */\r\n.admin-sidebar {\r\n  width: 280px;\r\n  background: rgba(255, 255, 255, 0.08);\r\n  backdrop-filter: blur(25px);\r\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n  z-index: 999;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: \r\n    4px 0 25px rgba(0, 0, 0, 0.15),\r\n    0 0 50px rgba(0, 245, 255, 0.05);\r\n}\r\n\r\n.admin-sidebar::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: \r\n    linear-gradient(180deg, \r\n      rgba(0, 245, 255, 0.02) 0%, \r\n      rgba(0, 102, 255, 0.02) 50%, \r\n      rgba(138, 43, 226, 0.02) 100%);\r\n  z-index: -1;\r\n}\r\n\r\n.admin-sidebar.collapsed {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n/* 移动端菜单按钮 - 全局样式确保在所有页面可见 */\r\n.mobile-menu-btn {\r\n  display: none;\r\n  position: fixed !important;\r\n  top: 20px !important;\r\n  left: 20px !important;\r\n  z-index: 1001 !important;\r\n  background: rgba(255, 255, 255, 0.15) !important;\r\n  backdrop-filter: blur(15px) !important;\r\n  border: 2px solid rgba(255, 255, 255, 0.3) !important;\r\n  border-radius: 16px !important;\r\n  padding: 12px 20px !important;\r\n  flex-direction: row !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  gap: 10px !important;\r\n  cursor: pointer !important;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\r\n  box-shadow: \r\n    0 8px 25px rgba(0, 0, 0, 0.2),\r\n    0 0 20px rgba(0, 245, 255, 0.1) !important;\r\n  min-width: 100px !important;\r\n}\r\n\r\n.mobile-menu-btn.menu-open {\r\n  background: rgba(255, 69, 69, 0.15) !important;\r\n  border-color: rgba(255, 69, 69, 0.5) !important;\r\n  box-shadow: \r\n    0 8px 25px rgba(255, 69, 69, 0.3),\r\n    0 0 20px rgba(255, 69, 69, 0.2) !important;\r\n}\r\n\r\n.mobile-menu-btn.menu-open .menu-icon span {\r\n  background: #ff4545 !important;\r\n}\r\n\r\n.mobile-menu-btn.menu-open .menu-text {\r\n  color: #ff4545 !important;\r\n}\r\n\r\n.menu-icon {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.menu-icon span {\r\n  width: 20px;\r\n  height: 2px;\r\n  background: white !important;\r\n  border-radius: 1px;\r\n  transition: all 0.3s;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.menu-open .menu-icon span:nth-child(1) {\r\n  transform: rotate(45deg) translate(5px, 5px);\r\n}\r\n\r\n.menu-open .menu-icon span:nth-child(2) {\r\n  opacity: 0;\r\n}\r\n\r\n.menu-open .menu-icon span:nth-child(3) {\r\n  transform: rotate(-45deg) translate(7px, -6px);\r\n}\r\n\r\n.menu-text {\r\n  color: white !important;\r\n  font-size: 14px !important;\r\n  font-weight: 600 !important;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;\r\n  letter-spacing: 0.5px !important;\r\n  min-width: 35px !important;\r\n  text-align: center !important;\r\n}\r\n\r\n.mobile-menu-btn:hover {\r\n  background: rgba(255, 255, 255, 0.25) !important;\r\n  border-color: rgba(0, 245, 255, 0.5) !important;\r\n  transform: translateY(-2px) scale(1.05) !important;\r\n  box-shadow: \r\n    0 12px 35px rgba(0, 0, 0, 0.3),\r\n    0 0 30px rgba(0, 245, 255, 0.2) !important;\r\n}\r\n\r\n.mobile-menu-btn:hover .menu-icon span {\r\n  background: #00f5ff !important;\r\n  box-shadow: 0 0 8px rgba(0, 245, 255, 0.5) !important;\r\n}\r\n\r\n.mobile-menu-btn:hover .menu-text {\r\n  color: #00f5ff !important;\r\n  text-shadow: 0 0 8px rgba(0, 245, 255, 0.3) !important;\r\n}\r\n\r\n.mobile-menu-btn.menu-open:hover {\r\n  background: rgba(255, 69, 69, 0.25) !important;\r\n  border-color: rgba(255, 69, 69, 0.7) !important;\r\n  box-shadow: \r\n    0 12px 35px rgba(255, 69, 69, 0.4),\r\n    0 0 30px rgba(255, 69, 69, 0.3) !important;\r\n}\r\n\r\n.mobile-menu-btn.menu-open:hover .menu-icon span {\r\n  background: #ff2d2d !important;\r\n  box-shadow: 0 0 8px rgba(255, 45, 45, 0.5) !important;\r\n}\r\n\r\n.mobile-menu-btn.menu-open:hover .menu-text {\r\n  color: #ff2d2d !important;\r\n  text-shadow: 0 0 8px rgba(255, 45, 45, 0.3) !important;\r\n}\r\n\r\n.mobile-menu-btn:active {\r\n  transform: translateY(0) scale(0.98) !important;\r\n}\r\n\r\n/* 管理页面容器样式 */\r\n.admin-page-container {\r\n  padding-top: 40px;\r\n}\r\n\r\n/* 响应式设计 */\r\n@media (max-width: 768px) {\r\n  .admin-sidebar {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100vh;\r\n    width: 300px;\r\n    z-index: 999;\r\n  }\r\n\r\n  .admin-main {\r\n    width: 100%;\r\n  }\r\n\r\n  .mobile-menu-btn {\r\n    display: flex !important;\r\n  }\r\n\r\n  .admin-page-container {\r\n    padding-top: 100px !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .admin-sidebar {\r\n    width: 280px;\r\n  }\r\n\r\n  .admin-page-container {\r\n    padding-top: 100px !important;\r\n  }\r\n}\r\n\r\n/* 底部登出按钮区域 */\r\n.sidebar-logout {\r\n  padding: 16px;\r\n  border-top: 1px solid #34495e;\r\n  text-align: center;\r\n}\r\n\r\n/* 右侧主区域 */\r\n.admin-main {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* 可选顶部栏 */\r\n.admin-header {\r\n  height: 50px;\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #ddd;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 20px;\r\n}\r\n\r\n/* 内容区域 */\r\n.admin-content {\r\n  flex: 1; \r\n  padding: 20px;\r\n  overflow: auto;\r\n  background-color: #ffffff; /* 主内容白底 */\r\n  box-shadow: inset 0 0 5px rgba(0,0,0,0.1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
